import gql from 'graphql-tag';

export default gql`
  fragment poolFragment on Pool {
    id
    uuid
  }
`;
